/* --- YMM Results Page: Redirect product clicks to Walmart URL when a "Walmart ID" metafield is set --- */
(function () {
  console.log("[YMM Walmart] ymm-walmart-redirect.js loaded, path:", window.location.pathname);

  // The official YMM app embed sets "ymmSearchURL" (a plain global var, read at search time from
  // multiple triggers - Search button click, Auto Search, View Fitments, Add My Bike, etc. - across
  // ymm-searchbox-new-version.js/ymm-my-garage.js) to its own default results page. That embed block
  // is auto-injected by Shopify right before </body> - AFTER this script tag - so a plain one-time
  // assignment here would get silently overwritten by the embed's own "var ymmSearchURL = ...;" that
  // runs later. Instead, lock it behind a getter/setter: the embed's later "var" assignment still
  // goes through normal property [[Set]] semantics (since the binding already exists), which our
  // setter simply ignores, guaranteeing our value always wins regardless of trigger or load order.
  var ymmFixedSearchURL = "/pages/product-result";
  try {
    Object.defineProperty(window, "ymmSearchURL", {
      configurable: true,
      enumerable: true,
      get: function () { return ymmFixedSearchURL; },
      set: function () { /* ignore attempts by other scripts to overwrite this */ }
    });
  } catch (err) {
    // "ymmSearchURL" was already defined elsewhere as non-configurable - fall back to a plain
    // assignment (harmless no-op if that existing property has no setter) so the rest of this
    // script still runs instead of the whole IIFE crashing on this uncaught TypeError.
    console.log("[YMM Walmart] Could not lock ymmSearchURL, falling back to plain assignment: " + err);
    try { window.ymmSearchURL = ymmFixedSearchURL; } catch (err2) {}
  }

  // window.cwsApp.ymmURLRedirect(ymmTildeTag) asks the server for a "single product/custom URL"
  // shortcut and, when the searched Y/M/M/Trim matches exactly one product, navigates straight to
  // that product page instead of the results grid. It's called from multiple triggers (Search button
  // click, "Auto Search" on dropdown change, "View Fitments", "Add My Bike", etc.) - not just a click
  // on "#ymm_search" - so this patches it directly, once, right after the embed's own script defines
  // it (it's assigned exactly once at page load and never reassigned afterward), to cover every
  // trigger uniformly and always land on the results page instead.
  function ymmPatchURLRedirect() {
    if (!window.cwsApp || typeof window.cwsApp.ymmURLRedirect !== "function") return false;
    if (window.cwsApp.ymmURLRedirect.__ymmWalmartPatched) return true;

    var ymmPatched = function (ymmTildeTag) {
      // ymmTildeTag and the "rq" query param both encode the same dropdown values in the same
      // order - just joined with "~" vs "__" respectively - so this rebuilds the results-page
      // query string without needing a server round trip.
      var ymmRqTag = ymmTildeTag.split("~").join("__");
      window.location.href = window.ymmSearchURL + "?rq=" + encodeURIComponent(ymmRqTag);
    };

    ymmPatched.__ymmWalmartPatched = true;
    window.cwsApp.ymmURLRedirect = ymmPatched;
    return true;
  }

  if (!ymmPatchURLRedirect()) {
    var ymmPatchRetryInterval = setInterval(function () {
      if (ymmPatchURLRedirect()) clearInterval(ymmPatchRetryInterval);
    }, 50);

    // Safety stop after 20s in case the embed never defines it on this page.
    setTimeout(function () { clearInterval(ymmPatchRetryInterval); }, 20000);
  }

  var ymmProductMetaCache = {};

  function ymmBuildWalmartUrl(value) {
    if (!value) return "";

    value = value.toString().trim();

    if (value === "") return "";

    // If metafield already stores a full URL, use it as-is.
    if (/^https?:\/\//i.test(value)) return value;

    // Otherwise, treat it as a Walmart Item ID and build the URL.
    return "https://www.walmart.com/ip/" + encodeURIComponent(value);
  }

  function ymmGetProductHandle(href) {
    try {
      var ymmUrl = new URL(href, window.location.origin);
      var ymmParts = ymmUrl.pathname.split("/products/");
      if (ymmParts.length < 2) return "";
      return ymmParts[1].split("/")[0];
    } catch (err) {
      return "";
    }
  }

  async function ymmFetchProductMeta(handle) {
    // Return cached value if already fetched for this product handle.
    if (Object.prototype.hasOwnProperty.call(ymmProductMetaCache, handle)) {
      return ymmProductMetaCache[handle];
    }

    try {
      // Fetch walmart_id/category from the product.metafields.liquid alternate template.
      // Returns: { "walmart_id": "...", "category": "..." }
      var ymmResponse = await fetch("/products/" + handle + "?view=metafields", { method: "GET" });

      if (!ymmResponse.ok) throw new Error("HTTP error! Status: " + ymmResponse.status);

      var ymmResult = await ymmResponse.json();
      ymmProductMetaCache[handle] = { walmart_id: ymmResult.walmart_id || "", category: ymmResult.category || "" };
    } catch (err) {
      console.log("YMM Walmart metafield fetch error: " + err);
      ymmProductMetaCache[handle] = { walmart_id: "", category: "" };
    }

    return ymmProductMetaCache[handle];
  }

  async function ymmFetchWalmartId(handle) {
    var ymmMeta = await ymmFetchProductMeta(handle);
    return ymmMeta.walmart_id;
  }

  async function ymmProductClickHandler(e) {
    // Use event delegation so product links added by the YMM app after page load
    // (pagination/infinite scroll) are also handled. Matched via ".ymm-product-item"
    // (confirmed present in the live DOM) instead of "#product_container", which may
    // not always wrap the grid depending on the app's markup.
    var ymmProductItem = e.target.closest(".ymm-product-item");
    var ymmLink = ymmProductItem && e.target.closest('a[href*="/products/"]');
    if (!ymmLink) return;

    // Preserve native browser behavior for new tabs, downloads, and non-primary clicks.
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || ymmLink.target === "_blank") return;

    var ymmOriginalHref = ymmLink.href;
    var ymmHandle = ymmGetProductHandle(ymmOriginalHref);
    if (!ymmHandle) return;

    e.preventDefault();

    var ymmWalmartId = await ymmFetchWalmartId(ymmHandle);
    var ymmWalmartUrl = ymmBuildWalmartUrl(ymmWalmartId);

    // Redirect to Walmart URL if available, otherwise fall back to the Shopify product URL.
    window.location.href = ymmWalmartUrl || ymmOriginalHref;
  }

  // Capture phase ensures the redirect runs before page/app click handlers can
  // cancel the click event.
  document.addEventListener("click", ymmProductClickHandler, true);

  /* --- Make "View Details" navigate to the normal Shopify product detail page instead of
     toggling the additional-info metadata list --- */

  function ymmViewDetailsClickHandler(e) {
    var ymmBtn = e.target.closest(".ymm_view_more_dtl, .ymm_view_less_dtl");
    if (!ymmBtn) return;

    var ymmProductItem = ymmBtn.closest(".ymm-product-item");
    var ymmLink = ymmProductItem && ymmProductItem.querySelector('a[href*="/products/"]');
    if (!ymmLink) return;

    // Stop the app's own "toggle additional info" click handler from running.
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    window.location.href = ymmLink.href;
  }

  document.addEventListener("click", ymmViewDetailsClickHandler, true);

  /* --- Inject a "Buy it on Walmart" button below "View Details" on each product card --- */

  function ymmCreateBuyButton(actionDiv) {
    var ymmLink = actionDiv.querySelector('a[href*="/products/"]') ||
      (actionDiv.closest(".ymm-product-item") && actionDiv.closest(".ymm-product-item").querySelector('a[href*="/products/"]'));

    if (!ymmLink) {
      console.log("[YMM Walmart] Buy button: no product link found near", actionDiv);
      return;
    }

    var ymmHandle = ymmGetProductHandle(ymmLink.href);
    if (!ymmHandle) {
      console.log("[YMM Walmart] Buy button: could not resolve handle from", ymmLink.href);
      return;
    }

    console.log("[YMM Walmart] Injecting Buy button for handle:", ymmHandle);

    var ymmBtn = document.createElement("button");
    ymmBtn.type = "button";
    ymmBtn.className = "ymm_buy_on_walmart_btn";
    ymmBtn.textContent = "Buy it on Walmart";

    ymmBtn.style.cssText = "display:block;margin-top:14px;width:41%;padding:8px 15px;background:#0071ce;color:#ffffff;border:1px solid #0071ce;border-radius:4px;font-size:13px;font-weight:600;cursor:pointer;left: 108px;";

    ymmBtn.addEventListener("click", async function (e) {
      e.preventDefault();
      e.stopPropagation();

      var ymmWalmartId = await ymmFetchWalmartId(ymmHandle);
      var ymmWalmartUrl = ymmBuildWalmartUrl(ymmWalmartId);
      if (!ymmWalmartUrl) return;

      window.open(ymmWalmartUrl, "_blank", "noopener");
    });

    actionDiv.appendChild(ymmBtn);
  }

  function ymmInjectBuyButtons(root) {
    var ymmActionDivs = (root.matches && root.matches(".ymm_prd_action"))
      ? [root]
      : root.querySelectorAll(".ymm_prd_action");

    ymmActionDivs.forEach(function (ymmActionDiv) {
      if (ymmActionDiv.querySelector(".ymm_buy_on_walmart_btn")) return;
      ymmCreateBuyButton(ymmActionDiv);
    });
  }

  /* --- Hide the raw Walmart URL text shown under "Hide Details" (rendered by the app's own
     "Custom Data Display" feature, configured in the app admin to show the walmart_id metafield) --- */

  function ymmHideWalmartUrlText(root) {
    var ymmItems = (root.matches && root.matches("ul.ymm_meta_cont li"))
      ? [root]
      : root.querySelectorAll("ul.ymm_meta_cont li");

    ymmItems.forEach(function (ymmItem) {
      if (ymmItem.dataset.ymmWalmartHidden) return;

      if (/https?:\/\/(www\.)?walmart\.com/i.test(ymmItem.textContent)) {
        ymmItem.style.display = "none";
        ymmItem.dataset.ymmWalmartHidden = "1";
      }
    });
  }

  /* --- Inject a category label between the product name and price on each product card --- */

  async function ymmInjectCategoryLabel(productItem) {
    if (productItem.querySelector(".ymm_category_label")) return;

    var ymmLink = productItem.querySelector('a[href*="/products/"]');
    if (!ymmLink) return;

    var ymmHandle = ymmGetProductHandle(ymmLink.href);
    if (!ymmHandle) return;

    var ymmTitle = productItem.querySelector(".grid-view-item__title");
    if (!ymmTitle) return;

    var ymmMeta = await ymmFetchProductMeta(ymmHandle);
    if (!ymmMeta.category) return;

    // Guard again in case of concurrent calls while the fetch above was pending.
    if (productItem.querySelector(".ymm_category_label")) return;

    var ymmCategoryEl = document.createElement("div");
    ymmCategoryEl.className = "ymm_category_label";
    ymmCategoryEl.textContent = ymmMeta.category;
    // Hidden per client request (for now) - kept in DOM/logic intact so it can be
    // re-enabled later by simply removing "display:none;" below.
    ymmCategoryEl.style.cssText = "display:none;font-size:12px;font-weight:600;text-transform:uppercase;letter-spacing:0.02em;opacity:0.7;margin:4px 0 0;";

    ymmTitle.insertAdjacentElement("afterend", ymmCategoryEl);
  }

  function ymmInjectCategoryLabels(root) {
    var ymmProductItems = (root.matches && root.matches(".ymm-product-item"))
      ? [root]
      : root.querySelectorAll(".ymm-product-item");

    ymmProductItems.forEach(ymmInjectCategoryLabel);
  }

  function ymmObserveProductContainer() {
    // Handle product cards already present (in case observer attaches after render).
    ymmInjectBuyButtons(document);
    ymmInjectCategoryLabels(document);
    ymmHideWalmartUrlText(document);

    // Observe the whole document body instead of "#product_container" directly,
    // since that container itself may be created dynamically by the YMM app
    // after this script runs (observing it directly would then silently miss it).
    var ymmObserver = new MutationObserver(function (mutations) {
      var ymmAddedCount = 0;

      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          ymmAddedCount++;
          ymmInjectBuyButtons(node);
          ymmInjectCategoryLabels(node);
          ymmHideWalmartUrlText(node);
        });
      });

      
      if (ymmAddedCount > 0) console.log("[YMM Walmart] MutationObserver processed", ymmAddedCount, "added node(s)");
    });

    ymmObserver.observe(document.body, { childList: true, subtree: true });
    console.log("[YMM Walmart] Buy button observer attached to document.body");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", ymmObserveProductContainer);
  } else {
    ymmObserveProductContainer();
  }
})();
